
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { PerfilUserService } from '../../../features/perfil-user/service/perfil-user.service';
import { map, take } from 'rxjs';
import { Store } from '@ngrx/store';
import { toSignal } from '@angular/core/rxjs-interop';
import { setBalance } from '../../../features/perfil-user/store/balance.actions';
import { AppState } from '../../../store/app.state';
import { getBalance } from '../../../features/perfil-user/store/balance.selector';
@Component({
  selector: 'shared-balance',
  imports: [],
  templateUrl: './balance.component.html',
  styleUrl: './balance.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BalanceComponent implements OnInit {

  store = inject(Store<AppState>);
  balance = toSignal(this.store.select(getBalance), { initialValue: '0' });
  constructor(private perfileUserSerice: PerfilUserService) {

  }


  ngOnInit(): void {
    // Solo actualizar el balance si está en el valor inicial
    this.store.select(getBalance).pipe(take(1)).subscribe(currentBalance => {
      if (currentBalance === '0') {
        this.perfileUserSerice.getProfile().pipe(
          map(response => response.data.balance)
        ).subscribe(balance => {
          this.store.dispatch(setBalance({ balance }))
        });
      }
    });
  }
}
